var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error404"},[_c('div',{staticClass:"error404-body-con"},[_c('Card',[_c('div',{staticClass:"error404-body-con-title"},[_vm._v("无权限使用"),_c('span'),_vm._v("请联系管理员")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }